import React = require('react');
import { defaultMemoize } from 'reselect';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { Subspace, TabbedSpace } from '~src/spacesPlatform/components/spaceComponents/TabbedSpace';
import { ISpaceInfoTypeItemCount } from '~src/spacesPlatform/state/ContentCountsState';
import { GroupSetSubspaceName, SpaceInfo, SubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { IGroupSetBasicInfo,IGroupSetInfo } from '../../models/IGroupSetInfo';
import { GroupSetGroupsSubspace } from './GroupSetGroupsSubspace';
import { GroupSetSpaceHeader } from './GroupSetSpaceHeader';

export interface GroupSetSpaceStateProps {
  readonly spaceInfo: SpaceInfo;
  readonly contentCounts: ISpaceInfoTypeItemCount<'groupset'>;
  readonly contentCountsUpToDate: boolean;
  readonly canSessionUserManageUsers: boolean;
}

export interface GroupSetSpaceOwnProps {
  readonly urls: SpacesSiteUrls;
  readonly reloadSpace: () => void;
}

export interface GroupSetSpaceDispatchProps {
  readonly fetchUpdatedContentCounts: () => void;
  readonly addGroupsToGroupSet?: (groupSet: IGroupSetInfo) => void;
}

export type GroupSetSpaceProps = GroupSetSpaceStateProps & GroupSetSpaceOwnProps & GroupSetSpaceDispatchProps;

export class GroupSetSpace extends React.PureComponent<GroupSetSpaceProps> {

  private memoizedGetGroupSetSubspaces = defaultMemoize(getGroupSetSubspaces);

  public componentDidUpdate(): void {
    this.props.fetchUpdatedContentCounts();
  }

  public componentDidMount(): void {
    this.props.fetchUpdatedContentCounts();
  }

  public render() {
    const groupSet = this.props.spaceInfo.item as IGroupSetBasicInfo;


    const subspaces = this.memoizedGetGroupSetSubspaces(
      this.props.contentCountsUpToDate,
      this.props.contentCounts,
      groupSet,
      this.props.addGroupsToGroupSet
    );
    return (
      <TabbedSpace
        subspaces = {subspaces}
        activeSubspaceName = {this.props.spaceInfo.subspaceName}
        urlForSubspace = {this.getGroupSetSubspaceUrl}
        mastheadElement = {this.mastheadElement()}
        testIdPrefix = {'groupsetspace'}
        spaceItemName = {groupSet.id}
      />
    );
  }

  private mastheadElement(): React.ReactNode {
    return <GroupSetSpaceHeader
      item={this.props.spaceInfo.item as IGroupSetInfo}
    />;
  }
  private static groupUrlBySubspace: Record<GroupSetSubspaceName, (urls: SpacesSiteUrls, groupId: string) => string> = {
    groups: (urls, groupId) =>  urls.groupSetGroupsUrl(groupId)
  };

  private getGroupSetSubspaceUrl = (subspaceName?: GroupSetSubspaceName) => {
    let url = this.props.urls.groupSetUrl(this.props.spaceInfo.item.id);
    if (subspaceName) {
      const urlFn = GroupSetSpace.groupUrlBySubspace[subspaceName];
      url = urlFn && urlFn(this.props.urls, this.props.spaceInfo.item.id) || url;
    }
    return url;
  };
}

function getGroupSetSubspaces(
  contentCountsUpToDate: boolean,
  contentCounts: ISpaceInfoTypeItemCount<'groupset'>,
  groupSet: IGroupSetBasicInfo,
  addGroupsToGroupSet: (group: IGroupSetInfo) => void
): ReadonlyArray<Subspace> {
  return _.compact([
    {
      name: 'groups' as SubspaceName,
      tabLabel: Messages.groupSetDetailsTab(),
      shouldRenderTabContentCount: true,
      tabContentCount: contentCounts && groupSet.groupCount,
      tabContentCountUpToDate: contentCountsUpToDate,
      renderContent: () => {
        return (<GroupSetGroupsSubspace
                  groupSet={groupSet}
                  canSessionUserManageUsers={true/*canSessionUserManageUsers*/}
                  addGroupsToGroupSet={addGroupsToGroupSet} />);
      }

    }
  ]);
}